import React, { useState, Fragment, useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Card,
  CardBody,
  CardHeader,
  Form,
  FormGroup,
  Input,
  Row,
  Col,
  Label,
} from "reactstrap";
import { Breadcrumbs, Btn, H4 } from "../../../../AbstractElements";
import DataTable from "react-data-table-component";
// import { reportType, reportTypetableColumns  } from '../../../../Data/GeneralSettings';
import { toast } from "react-toastify";
import SweetAlert from "sweetalert2";
import RequiredField from "../../../../Constant";
import CommonModal from "../../../Common/Component/CommonModal";
import {
  CreateMedicalReportType,
  DeleteMedicalReportType,
  MedicalReportTypeList,
  UpdateMedicalReportType,
} from "../../../../apiController";
import { roles_permissions } from "../../../../Layout/Sidebar/Menu";
const MedicalReportType = () => {
  const [Large, setLarge] = useState(false);
  const permission = roles_permissions.find(
    (module) => module.module_name === "Medical Report Type"
  );

  const LargeModaltoggle = () => {
    setLarge(!Large);
    reset({ medicalreporttype: "" });
  };

  const [formdata, setFormdata] = useState({});
  const [medicalreportType, setReportType] = useState([]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [searchKeyword, setSearchKeyword] = useState("");
  const handleSearchKeyword = (keyword) => {
    setSearchKeyword(keyword);
    // searchMember(keyword);
  };

  const handleEdit = (row) => {
    console.log(row);
    setFormdata({ id: row.id, medicalreporttype: row.name });
    setLarge(!Large);
    reset({ medicalreporttype: row.name });
  };

  const reportType = medicalreportType.map((row, ind) => ({
    ind: ind + 1,
    id: row.id,
    reporttype: row.name !== undefined ? row.name : "",
    action: (
      <span>
        <Btn
          attrBtn={{
            style: { width: 60, fontSize: 14, padding: 4 },
            color: "success",
            className: "btn btn-xs",
            type: "button",
            onClick: () => handleEdit(row),
          }}
        >
          Edit
        </Btn>
      </span>
    ),
  }));

  const reportTypetableColumns = [
    {
      name: "#",
      selector: (row) => row["ind"],
      sortable: true,
      center: false,
    },
    {
      name: "Medical Report Type",
      selector: (row) => row["reporttype"],
      sortable: true,
      center: false,
    },
    // {
    //     name: 'Action',
    //     selector: row => row.action,
    //     sortable: false,
    //     center: true,
    // },
  ];

  if (permission?.edit_access) {
    reportTypetableColumns.push({
      name: "Action",
      selector: (row) => row["action"],
      sortable: false,
      center: true,
    });
  }

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleDelet, setToggleDelet] = useState(false);
  const [data, setData] = useState(reportType);

  const handleSaveForm = async (data) => {
    const formattedData = {
      name: data.medicalreporttype,
      id: formdata.id,
    };

    try {
      if (formdata.id) {
        const response = await UpdateMedicalReportType(formattedData);
        if (response.status === true) {
          setReportType((prev) =>
            prev.map((item) =>
              item.id === formdata.id
                ? { ...item, name: formattedData.name }
                : item
            )
          );
          toast.success("Updated Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
      } else {
        const response = await CreateMedicalReportType(formattedData);
        if (response.status === true) {
          setReportType((prev) => [...prev, response.data]);
          toast.success("Created Successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
      fetchMedicalReportType();
      LargeModaltoggle();
    } catch (error) {
      toast.error("An error occurred!", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
    reset({ medicalreporttype: "" });
  };
  const handleRowSelected = useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const handleDelete = async () => {
    const result = await SweetAlert.fire({
      title: "Are you sure you want to delete?",
      cancelButtonText: "No!",
      confirmButtonText: "Yes!",
      reverseButtons: true,
      showCancelButton: true,
    });

    if (result.isConfirmed) {
      try {
        const selectedIds = selectedRows.map((row) => row.id);
        await Promise.all(selectedIds.map((id) => DeleteMedicalReportType(id)));
        setReportType(
          medicalreportType.filter((item) => !selectedIds.includes(item.id))
        );
        setSelectedRows([]);
        toast.success("Deleted Successfully!", {
          position: toast.POSITION.TOP_CENTER,
        });
        fetchMedicalReportType();
      } catch (error) {
        toast.error("An error occurred!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };
  //   const handleSaveForm = async (data) => {
  //     console.log(data)
  //     const formattedData = {
  //       ...data,
  //       name: data.medicalreporttype,
  //       id: data.id
  //     };
  //     delete formattedData.medicalreporttype;
  //     console.log(formattedData)

  //     try {
  //       if (formattedData.id) {
  //         const response = await UpdateMedicalReportType(formattedData.id, formattedData);
  //         if (response.status === true) {
  //           setReportType(prev => prev.map(item => item.id === data.id ? { ...item, name: formattedData.name } : item));
  //           toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
  //         }
  //         fetchMedicalReportType();
  //       } else {
  //         const response = await CreateMedicalReportType(formattedData);
  //         if (response.status === true) {
  //           toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
  //           setReportType(prev => [...prev, response.data]);
  //           LargeModaltoggle()
  //         }
  //         fetchMedicalReportType();
  //       }
  //     } catch (error) {
  //       toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  //     }
  //     reset({medicalreporttype:''})
  //   };

  //   const handleRowSelected = useCallback(state => {
  //     setSelectedRows(state.selectedRows);
  // }, []);

  // const handleDelete = async () => {
  //   const result = await SweetAlert.fire({
  //     title: 'Are you sure you want to delete?',
  //     cancelButtonText: 'No!',
  //     confirmButtonText: 'Yes!',
  //     reverseButtons: true,
  //     showCancelButton: true,
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       await Promise.all(selectedRows.map(row => DeleteMedicalReportType(row.id)));
  //       setReportType(medicalreportType.filter(dept => !selectedRows.includes(dept)));
  //       setSelectedRows([]);
  //       toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
  //     } catch (error) {
  //       toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
  //     }
  //   }
  // };

  const fetchMedicalReportType = async () => {
    const response = await MedicalReportTypeList();
    if (response.status === true) {
      setReportType(response.data);
    }
  };

  useEffect(() => {
    fetchMedicalReportType();
  }, []);

  // const handleDelete = () => {
  //   SweetAlert.fire({
  //     title: 'Are you sure you want to do to delete?',
  //     cancelButtonText: 'no!',
  //     confirmButtonText: 'yes!',
  //     reverseButtons: true,
  //     showCancelButton: true,
  // })
  // setToggleDelet(!toggleDelet)
  // setData(data.filter((item) => selectedRows.filter((elem) => elem.id === item.id).length > 0 ? false : true));
  // setSelectedRows([]);

  //     toast.error('Danger Notification !', {
  //       position: toast.POSITION.TOP_CENTER
  //     })
  // };
  return (
    <Card>
      <Breadcrumbs
        mainTitle="Medical Report Type"
        parent="Dashboard"
        title="medicalreporttype"
      />
      <CardHeader className="card-no-border">
        <div className="header-top">
          <Fragment>
            <div className="search">
              <Form className="theme-form">
                <FormGroup className="form-group">
                  <div className="input-group">
                    <Input
                      className="form-control"
                      type="text"
                      placeholder="search"
                      defaultValue={searchKeyword}
                      onChange={(e) => handleSearchKeyword(e.target.value)}
                    />
                    <div className="input-group-append">
                      <span className="input-group-text">
                        <i className="fa fa-search"></i>
                      </span>
                    </div>
                  </div>
                </FormGroup>
              </Form>
            </div>
          </Fragment>
          <div className="card-header-right-icon">
            {/* <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} /> */}
            <div className="card-header-right-icon">
             {permission?.create_access &&  <Btn
                attrBtn={{
                  color: "light-primary",
                  className: "btn badge-light-primary",
                  onClick: LargeModaltoggle,
                }}
              >
                + Add Medical Report Type
              </Btn>}
              <CommonModal
                isOpen={Large}
                title={"Medical Report Type"}
                toggler={LargeModaltoggle}
                size="lg"
                onSave={handleSubmit(handleSaveForm)}
                formdata={formdata}
              >
                <Row>
                  <Col sm="12">
                    <FormGroup className="mb-3">
                      <Label htmlFor="fname">
                        {"Medical Report Type"} <RequiredField />
                      </Label>
                      <input
                        className={`form-control ${
                          errors.medicalreporttype && "is-invalid"
                        }`}
                        id="medicalreporttype"
                        type="text"
                        name="medicalreporttype"
                        defaultValue={formdata.medicalreporttype || ""}
                        {...register("medicalreporttype", { required: true })}
                      />
                      <span className="text-danger">
                        {errors.medicalreporttype &&
                          "Medical Report Type is required"}
                      </span>
                    </FormGroup>
                  </Col>
                </Row>
              </CommonModal>
            </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className="pt-0 campaign-table">
        <div className="recent-table table-responsive currency-table">
          <Fragment>
            {selectedRows.length !== 0 && (
              <div
                className={`d-flex align-items-center justify-content-between bg-light-info p-2`}
              >
                <H4 attrH4={{ className: "text-muted m-0" }}>
                  Delet Selected Data..!
                </H4>
                <Btn
                  attrBtn={{ color: "danger", onClick: () => handleDelete() }}
                >
                  Delete
                </Btn>
              </div>
            )}
            <DataTable
              data={reportType}
              columns={reportTypetableColumns}
              striped={true}
              center={true}
              pagination
              selectableRows = {permission?.delete_access}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleDelet}
            />
          </Fragment>
        </div>
      </CardBody>
    </Card>
  );
};

export default MedicalReportType;
